import React from 'react';
import {Row} from "react-flexbox-grid";
import Form from 'react-bootstrap/Form';

const labelHeadingStyle = {
    color: 'black',
    marginLeft:'-35px',
}
const IPSLocationHeader = () =>
    <Form.Group as={Row} controlId="ipslocationsHeading">
        <Form.Label style={labelHeadingStyle} className="col-xs-12 col-md-3"><strong> Project IPS Locations:*</strong></Form.Label>
    </Form.Group>;

export default IPSLocationHeader;
